(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Open lookbook popup
    document.querySelectorAll('.lookbook-card').forEach(card => {
      card.addEventListener('click', () => {
        const id = card.dataset.open;
        const dialog = document.getElementById(id);
        if (dialog) {
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
      });
    });

    // Close on close button
    document.querySelectorAll('.lookbook-popup__close').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('dialog').close();
      });
    });

    // Close on backdrop click
    document.querySelectorAll('.lookbook-popup').forEach(dialog => {
      dialog.addEventListener('click', e => {
        if (e.target === dialog) dialog.close();
      });
      // Restore scroll on any close (including ESC)
      dialog.addEventListener('close', () => {
        document.body.style.overflow = '';
      });
    });

    // Add to cart
    document.querySelectorAll('.lookbook-product__atc').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const originalText = btn.textContent;
        btn.classList.add('lookbook-product__atc--loading');
        btn.textContent = '...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });

          if (res.ok) {
            btn.classList.remove('lookbook-product__atc--loading');
            btn.classList.add('lookbook-product__atc--success');
            btn.textContent = '✓ Ajouté';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => {
              btn.classList.remove('lookbook-product__atc--success');
              btn.textContent = originalText;
            }, 2500);
          } else {
            throw new Error();
          }
        } catch {
          btn.classList.remove('lookbook-product__atc--loading');
          btn.textContent = 'Erreur — réessayer';
          setTimeout(() => { btn.textContent = originalText; }, 2000);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
